module.exports = __webpack_public_path__ + "static/media/jamnagar.a28d97bc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/backs/jamnagar.jpg
// module id = 1002
// module chunks = 0